import services from '../services'
import * as types from './mutation-types'

function generateId () {
  return '_' + Math.random().toString(36).substr(2, 9)
}

function compileBlocksToHtml (blocks) {
  return blocks.map(function (block) {
    switch (block.type) {
      case 'heading': {
        var style = (block.settings && block.settings.style) || 'banner'
        var align = (block.settings && block.settings.alignment) || 'center'
        var text = block.content || ''
        if (style === 'banner') {
          return '<div class="section-banner" style="text-align:' + align + ';">' + text + '</div>'
        } else if (style === 'simple') {
          return '<p class="section-simple" style="text-align:' + align + ';">' + text + '</p>'
        } else {
          return '<p class="section-underline" style="text-align:' + align + ';">' + text + '</p>'
        }
      }
      case 'text':
        return block.content || ''
      case 'flight-table': {
        var html = ''
        if (!block.settings || block.settings.showTitle !== false) {
          var title = (block.settings && block.settings.title) || 'VOOS CONFIRMADOS'
          html += '<div class="flight-section-title">' + title + '</div>'
        }
        html += '<div data-dynamic-table="aereo"></div>'
        var parts = []
        if (!block.settings || block.settings.showLocalizador !== false) {
          parts.push('<strong>Localizador:</strong> <span class="flight-meta-value">{$localizador}</span>')
        }
        if (block.settings && block.settings.showEticket) {
          parts.push('<strong>E-Ticket:</strong> <span class="flight-meta-value">{$eticket}</span>')
        }
        if (parts.length > 0) {
          html += '<p class="flight-meta">' + parts.join(' &nbsp;&middot;&nbsp; ') + '</p>'
        }
        return html
      }
      case 'accommodation': {
        var accHtml = ''
        var accSettings = block.settings || {}
        if (accSettings.showTitle !== false) {
          var accTitle = accSettings.title || 'HOSPEDAGEM'
          accHtml += '<div class="section-banner">' + accTitle + '</div>'
        }
        accHtml += '<div data-dynamic-table="hospedagem" data-source="' + (accSettings.source || 'auto') + '"></div>'
        return accHtml
      }
      case 'divider':
        return '<hr>'
      default:
        return ''
    }
  }).join('\n')
}

export var GetTemplates = function ({ commit }, params) {
  return services.list(params).then(function (res) {
    commit(types.SET_TEMPLATES, res.data)
  })
}

export var GetTemplate = async function ({ commit }, id) {
  commit(types.SET_LOADING, true)
  try {
    var res = await services.show(id)
    var data = res.data.data
    commit(types.SET_TEMPLATE, data)
    var blocks = (data.blocks || []).map(function (b) {
      return Object.assign({}, b, { _id: b._id || generateId() })
    })
    // Legacy: if no blocks but has content, wrap in single text block
    if (blocks.length === 0 && data.content) {
      blocks = [{ _id: generateId(), type: 'text', content: data.content, settings: {} }]
    }
    commit(types.SET_BLOCKS, blocks)
    commit(types.SET_DIRTY, false)
  } finally {
    commit(types.SET_LOADING, false)
  }
}

export var SaveTemplate = async function ({ commit, state }) {
  var template = state.template
  if (!template || !template.name || !template.name.trim()) {
    throw new Error('Insira o nome do template.')
  }

  commit(types.SET_SAVING, true)
  try {
    var blocksToSave = state.blocks.map(function (b) {
      var copy = Object.assign({}, b)
      delete copy._id
      return copy
    })
    var content = compileBlocksToHtml(state.blocks)
    var payload = {
      name: template.name.trim(),
      description: template.description || '',
      email_subject: template.email_subject || null,
      email_body: template.email_body || null,
      content: content,
      blocks: blocksToSave,
      header_image: template.header_image || null,
      header_mode: template.header_mode || 'logo',
      page_size: template.page_size || 'A4',
      orientation: template.orientation || 'portrait',
      margins: template.margins || null,
      target_groups: template.target_groups || null,
      target_tags: template.target_tags || null,
      is_active: template.is_active !== undefined ? template.is_active : true
    }

    var res = await services.save(template.id || null, payload)
    commit(types.SET_TEMPLATE, res.data.data)
    // Reload blocks from saved response
    var savedBlocks = (res.data.data.blocks || blocksToSave).map(function (b) {
      return Object.assign({}, b, { _id: b._id || generateId() })
    })
    commit(types.SET_BLOCKS, savedBlocks)
    commit(types.SET_DIRTY, false)
    return res
  } finally {
    commit(types.SET_SAVING, false)
  }
}

export var DeleteTemplate = async function ({ commit }, id) {
  await services.remove(id)
}

export var DuplicateTemplate = async function ({ commit }, id) {
  var res = await services.duplicate(id)
  return res.data.data
}

export var UpdateTemplateField = function ({ commit, state }, { field, value }) {
  if (state.template) {
    commit(types.SET_TEMPLATE, Object.assign({}, state.template, { [field]: value }))
    commit(types.SET_DIRTY, true)
  }
}

export var InitNewTemplate = function ({ commit }) {
  commit(types.SET_TEMPLATE, {
    id: null,
    name: '',
    description: '',
    content: '',
    header_image: null,
    page_size: 'A4',
    orientation: 'portrait',
    margins: { top: 20, right: 15, bottom: 20, left: 15 },
    target_groups: null,
    target_tags: null,
    is_active: true
  })
  commit(types.SET_BLOCKS, [])
  commit(types.SET_SELECTED_BLOCK, null)
  commit(types.SET_DIRTY, false)
}

export var AddBlock = function ({ commit }, { type, index, content, settings }) {
  var block = {
    _id: generateId(),
    type: type,
    content: content || '',
    settings: settings || {}
  }
  commit(types.ADD_BLOCK, { block: block, index: index })
  commit(types.SET_SELECTED_BLOCK, block._id)
  commit(types.SET_DIRTY, true)
  return block
}

export var UpdateBlock = function ({ commit }, { id, data }) {
  commit(types.UPDATE_BLOCK, { id: id, data: data })
  commit(types.SET_DIRTY, true)
}

export var RemoveBlock = function ({ commit }, id) {
  commit(types.REMOVE_BLOCK, id)
  commit(types.SET_DIRTY, true)
}

export var ReorderBlocks = function ({ commit }, blocks) {
  commit(types.SET_BLOCKS, blocks)
  commit(types.SET_DIRTY, true)
}

export var SelectBlock = function ({ commit }, id) {
  commit(types.SET_SELECTED_BLOCK, id)
}

export var LoadPresetTemplate = function ({ commit }, presetName) {
  var blocks = []

  if (presetName === 'viagem') {
    blocks = [
      { _id: generateId(), type: 'text', content: '<p>Olá, <strong>{$nome}</strong>!</p><p>É uma satisfação tê-lo como participante. Seguem abaixo algumas informações importantes para sua viagem:</p>', settings: {} },
      { _id: generateId(), type: 'heading', content: 'INFORMAÇÕES DO AEROPORTO', settings: { style: 'banner', alignment: 'center' } },
      { _id: generateId(), type: 'text', content: '<p><strong>Data:</strong> ___/___/______ – <strong>Horário:</strong> ___h___ – <strong>Local:</strong> Balcão da Cia Aérea ____________.</p><p>Recomendamos que a apresentação no aeroporto seja feita com, no mínimo, <strong>2 horas de antecedência para voos nacionais</strong> e <strong>3 horas de antecedência para voos internacionais</strong>.</p><p><strong>Importante:</strong> Não esqueça de levar o seu passaporte e visto válidos e originais.<br><strong>Limite de Bagagem:</strong> 01 mala com no máximo 23 kg cada por pessoa.</p>', settings: {} },
      { _id: generateId(), type: 'heading', content: 'VOOS CONFIRMADOS', settings: { style: 'banner', alignment: 'center' } },
      { _id: generateId(), type: 'flight-table', content: '', settings: { showTitle: false, showLocalizador: true, showEticket: false } },
      { _id: generateId(), type: 'heading', content: 'HOSPEDAGEM', settings: { style: 'banner', alignment: 'center' } },
      { _id: generateId(), type: 'text', content: '<p>Durante sua viagem, você contará com hospedagem nas seguintes cidades:</p><p><strong>Hotel:</strong> ____________<br><strong>Endereço:</strong> ____________<br><strong>Contato local:</strong> ____________</p><p><em>As reservas foram feitas em apartamento individual, com café da manhã incluso (quando aplicável).</em><br>Horários padrão de hospedagem: <strong>Check-in a partir das 14h | Check-out até às 12h</strong></p>', settings: {} },
      { _id: generateId(), type: 'divider', content: '', settings: {} },
      { _id: generateId(), type: 'text', content: '<p>Em caso de dúvidas, entrar em contato com ____________ através do celular de plantão: ____________.</p><p><strong>Desejamos a você uma ótima viagem!</strong></p>', settings: {} }
    ]
  } else if (presetName === 'viagem-completa') {
    blocks = [
      { _id: generateId(), type: 'text', content: '<p>Olá, <strong>{$nome}</strong>!</p><p>É uma satisfação tê-lo como participante do evento <strong>{$evento}</strong>. Abaixo estão as informações essenciais da sua viagem, cuidadosamente organizadas para você.</p>', settings: {} },
      { _id: generateId(), type: 'heading', content: 'INFORMAÇÕES DO AEROPORTO', settings: { style: 'banner', alignment: 'center' } },
      { _id: generateId(), type: 'text', content: '<p>Recomendamos que a apresentação no aeroporto seja feita com, no mínimo, <strong>2 horas de antecedência para voos nacionais</strong> e <strong>3 horas para voos internacionais</strong>.</p><p><strong>Importante:</strong> Leve documento de identificação original com foto. Para voos internacionais, passaporte e visto válidos são obrigatórios.</p>', settings: {} },
      { _id: generateId(), type: 'flight-table', content: '', settings: { source: 'auto', showTitle: true, title: 'SEUS VOOS', showLocalizador: true, showEticket: true } },
      { _id: generateId(), type: 'accommodation', content: '', settings: { source: 'auto', showTitle: true, title: 'SUA HOSPEDAGEM', showCompanions: true, showCategory: false, showNotes: true } },
      { _id: generateId(), type: 'heading', content: 'CONTATOS DE EMERGÊNCIA', settings: { style: 'banner', alignment: 'center' } },
      { _id: generateId(), type: 'text', content: '<p><strong>Atendimento 24h:</strong> ____________<br><strong>WhatsApp de plantão:</strong> ____________<br><strong>E-mail:</strong> ____________</p>', settings: {} },
      { _id: generateId(), type: 'divider', content: '', settings: {} },
      { _id: generateId(), type: 'text', content: '<p style="text-align:center;"><strong>Desejamos a você uma ótima viagem!</strong></p>', settings: {} }
    ]
  } else if (presetName === 'voucher') {
    blocks = [
      { _id: generateId(), type: 'text', content: '<p style="text-align:right;">{$data_atual}</p><p>Olá, <strong>{$nome}</strong>,</p><p>Com grande alegria, confirmamos sua participação no evento. Confira abaixo algumas informações importantes para sua organização:</p>', settings: {} },
      { _id: generateId(), type: 'heading', content: 'LOCAL DO EVENTO E DA HOSPEDAGEM', settings: { style: 'simple', alignment: 'left' } },
      { _id: generateId(), type: 'text', content: '<p><strong>Hotel:</strong> ____________<br><strong>Endereço:</strong> ____________</p>', settings: {} },
      { _id: generateId(), type: 'heading', content: 'AÉREO', settings: { style: 'simple', alignment: 'left' } },
      { _id: generateId(), type: 'flight-table', content: '', settings: { showTitle: false, showLocalizador: true, showEticket: true } },
      { _id: generateId(), type: 'text', content: '<p><strong>ATENÇÃO:</strong></p><ul><li>Recomendamos que você chegue ao aeroporto com, no mínimo, <strong>2 horas de antecedência</strong> ao horário de partida do seu voo;</li><li>Anote o <strong>código localizador</strong> da sua reserva aérea, pois ele deverá ser apresentado junto com um documento de identidade original;</li></ul>', settings: {} },
      { _id: generateId(), type: 'heading', content: 'DOCUMENTO PARA EMBARQUE', settings: { style: 'simple', alignment: 'left' } },
      { _id: generateId(), type: 'text', content: '<p>Para esta viagem, é necessário apresentar o <strong>RG original com foto recente</strong> ou uma <strong>CNH válida</strong>.</p>', settings: {} },
      { _id: generateId(), type: 'heading', content: 'HOSPEDAGEM', settings: { style: 'simple', alignment: 'left' } },
      { _id: generateId(), type: 'text', content: '<p><strong>Hotel:</strong> ____________<br><strong>Endereço:</strong> ____________</p><ul><li><strong>Check-in:</strong> a partir das 14h</li><li><strong>Check-out:</strong> até às 12h</li></ul>', settings: {} },
      { _id: generateId(), type: 'heading', content: 'CONTATOS EMERGENCIAIS', settings: { style: 'simple', alignment: 'left' } },
      { _id: generateId(), type: 'text', content: '<p><strong>Agência responsável:</strong> ____________<br><strong>Contato WhatsApp:</strong> ____________<br><strong>E-mail:</strong> ____________</p>', settings: {} },
      { _id: generateId(), type: 'divider', content: '', settings: {} },
      { _id: generateId(), type: 'text', content: '<p style="text-align:center;"><strong>É UMA HONRA CONTAR COM SUA PRESENÇA. DESEJAMOS UM EVENTO INCRÍVEL!</strong></p><p style="text-align:center;">Atenciosamente,<br>Equipe do Evento</p>', settings: {} }
    ]
  }

  commit(types.SET_BLOCKS, blocks)
  commit(types.SET_SELECTED_BLOCK, null)
  commit(types.SET_DIRTY, true)
}

export var LoadReferenceData = async function ({ commit }) {
  try {
    var results = await Promise.allSettled([
      services.getGroups(),
      services.getTags()
    ])

    commit(types.SET_REFERENCE_DATA, {
      groups: results[0].status === 'fulfilled' ? (results[0].value.data.data || results[0].value.data) : [],
      tags: results[1].status === 'fulfilled' ? (results[1].value.data.data || results[1].value.data) : []
    })
  } catch (e) {
    console.error('Failed to load reference data', e)
  }
}
